<template>
    <div class="page-table-layout" data-testid="location-new">
      <v-card :loading="loading" :disabled="loading" loader-height="2" class="all-width flex-card shadow-off" data-testid="location-new__main-card">
        <v-card-text class="page-table-layout__body" data-testid="location-new__main-content">
            <div class="d-flex align-center justify-space-between" data-testid="location-new__header-bar">
                <div class="d-flex align-center" data-testid="location-new__header-title-group">
                    <h3 class="ma-0 font-weight-medium" v-if="!editHeader" data-testid="location-new__header-title">{{$store.state.LocationHeader || 'Location'}}</h3>
                    <lb-string class="" v-if="editHeader" :isClearable="false" v-model="newHeader" label="" data-testid="location-new__header-title-input" />

                    <v-tooltip bottom content-class="tooltip-bottom" v-if="editHeader">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="shadow-off ml-1" icon @click="UpdateHeader" data-testid="location-new__header-submit-btn">
                                <v-icon size="24" data-testid="location-new__header-submit-icon">mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>Submit</span>
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-else>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" text @click="editHeader=true; newHeader=$store.state.LocationHeader " class="shadow-off ml-1" icon data-testid="location-new__header-edit-btn">
                                <v-icon size="24" data-testid="location-new__header-edit-icon">mdi-pencil-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>

                    <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="shadow-off ml-1" icon @click="refreshData()" data-testid="location-new__refresh-btn">
                                <v-icon size="24" data-testid="location-new__refresh-icon">mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Refresh</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center justify-center" data-testid="location-new__header-action-group">
                    <v-btn color="" class="mr-1 secondaryBtn px-4 py-1 "  @click="syncERP()" v-if="$store.state.erpEnabled.locationErpEnabled" data-testid="location-new__sync-erp-btn">
                        <v-icon class="pr-2" data-testid="location-new__sync-erp-icon">mdi-file-sync-outline</v-icon>
                        <p class="ma-0 pa-0" data-testid="location-new__sync-erp-label">Update From ERP</p>
                    </v-btn>
                    <v-btn  color="primary" class="mr-1 px-4" v-if="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add')" @click="locationdialog = true;locationdata = {};locationdataerror= {};" data-testid="location-new__add-btn">
                        <v-icon class="mr-1" data-testid="location-new__add-icon">mdi-plus</v-icon>
                        <span data-testid="location-new__add-label">Add {{$store.state.LocationHeader || 'Location'}}</span>
                    </v-btn>
                </div>
            </div>
            <p
                v-if="(lastRunData[0] || {}).lastupdated"
                class="ma-0 mt-4"
                data-testid="location-new__last-sync-label"
            >
                Last sync:
                <span data-testid="location-new__last-sync-value">{{ $nova.formatDateTime(new Date(lastRunData[0].lastupdated).getTime()) }}</span>
            </p>

            <div class="d-flex align-center ml-2 justify-space-between my-3 mr-1" data-testid="location-new__toolbar">
                <div class="d-none"> 
                    <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify" hidedetails :isClearable="false" radius="8px" />
                    <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on">
                                <v-icon>mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <span>Search for the description </span>
                    </v-tooltip>
                </div>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <!-- Clear Filter Button -->
                <v-btn
                    v-if="hasActiveTableFilter"
                    outlined
                    small
                    class="mr-2"
                    color="caccounting"
                    @click="clearTableFilter()"
                    data-testid="location-new__toolbar-clear-filter-btn"
                >
                    <v-icon left data-testid="location-new__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
                    <span>Clear Filter</span>
                </v-btn>
                <!-- CustomizeColumnMenu component - Apply only -->
                <CustomizeColumnMenu
                  v-model="customizeMenuOpen"
                  :headers="headers"
                  color="caccounting"
                  :show-save-button="false"
                  :show-apply-button="true"
                  data-testid-prefix="location-new"
                  @apply="handleApplyColumns"
                />
            </div>

            <div class="flex-fill-table">
            <lb-datatableaction
              ref="dataTableAction"
              :headers="headers"
              :tabledata="formatedDataCopy"
              :itemsperpage="itemsPerPage"
              :displayedRowCount="paginatedFilteredItems.length"
              :searchterm="search"
              :bulkActions="false"
              :selectfilter="activeColumnFilters"
              :page_details="page_details"
              @filter-item="filterPart"
              @filter-active-change="onFilterActiveChange"
              @clear-item="clearPart"
              data-testid="location-new__datatable"
            >
                <template v-slot:tbody>
                    <tr v-for="item in paginatedFilteredItems" :key="item._id" class="cursor-pointer" :class="{ 'low-opacity': item.status === false }" data-testid="location-new__row">
                        <template v-for="header in headers">
                            <td
                              v-if="header.visible && header.value !== 'action' && header.value !== 'ingestion_type'"
                              :key="header.value + '-' + item._id + '-value'"
                              :class="{'description-header': header.value === 'description'}"
                              class="px-2 single-line"
                              data-testid="location-new__cell"
                            >
                              <span data-testid="location-new__cell-value">{{ getItemData(item, header.value) }}</span>
                            </td>
                            <td
                              v-else-if="header.visible && header.value === 'ingestion_type'"
                              :key="header.value + '-' + item._id + '-ingestion'"
                              data-testid="location-new__ingestion-type-cell"
                            >
                              <div v-if="item.ingestion_type === 'Manual'">
                                  <span class="pa-2 caccounting-background radius-mini caccounting--text mr-2" data-testid="location-new__ingestion-type-manual">{{item.ingestion_type }}</span>
                              </div>
                              <div v-else>
                                  <span class="pa-2 caccounting-background radius-mini mr-2" data-testid="location-new__ingestion-type-other">{{item.ingestion_type }}</span>
                              </div>
                            </td>
                            <td
                              v-else-if="header.visible && header.value === 'action'"
                              :key="header.value + '-' + item._id + '-action'"
                              class="px-0 single-line border-right border-left action-data"
                              data-testid="location-new__action-cell"
                            >
                              <v-tooltip bottom content-class="tooltip-bottom">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon @click="editLocation(item)" :disabled="!item.status" data-testid="location-new__edit-btn">
                                    <v-icon data-testid="location-new__edit-icon">mdi-pencil-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>Edit</span>
                              </v-tooltip>
                              <v-tooltip bottom content-class="tooltip-bottom" v-if="item.status">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon @click="enableDisable(item._id, 'disable')" data-testid="location-new__enable-btn">
                                    <v-icon color="success" data-testid="location-new__enable-icon">mdi-check-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Enable</span>
                              </v-tooltip>
                              <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon @click="enableDisable(item._id, 'enable')" data-testid="location-new__disable-btn">
                                    <v-icon color="error" data-testid="location-new__disable-icon">mdi-close-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Disable</span>
                              </v-tooltip>
                              <activity-log
                                :resource-id="item._id" 
                                data-testid="location-new__activity-log-btn"
                                :row-description="item.name"
                            />
                            </td>
                        </template>
                    </tr>
                </template>
            </lb-datatableaction>
            </div>

        </v-card-text>
      </v-card>

      <lb-drawer v-model="locationdialog" :heading="locationdata._id ? 'Edit Location' : 'New Location'" width="600"
        :loading="locationdialogloading" data-testid="location-new__drawer">
        <template v-slot:body>
          <div data-testid="location-new__drawer-body">
            <v-row data-testid="location-new__drawer-row">
              <v-col cols="12" class="my-0 py-1" data-testid="location-new__drawer-col-name">
                <p class="pa-0 ma-0  text-font-size-md mb-1">{{$store.state.LocationHeader || 'Location'}} Name*</p>
                <lb-string v-model="locationdata.name" label="" :error="locationdataerror.name"  placeholder="Enter name" data-testid="location-new__drawer-name-input"/>
              </v-col>
  
              <v-col cols="12" class="my-0 py-1" data-testid="location-new__drawer-col-description">
                <p class="pa-0 ma-0  text-font-size-md mb-1">{{$store.state.LocationHeader || 'Location'}} Description*</p>
                <lb-textBox requriedrows="3" v-model="locationdata.description" label="" placeholder="Enter description"
                  :error="locationdataerror.description" data-testid="location-new__drawer-description-input" />
              </v-col>
              <v-col cols="6" class="my-0 py-1" data-testid="location-new__drawer-col-country">
                <p class="pa-0 ma-0  text-font-size-md mb-1">{{$store.state.LocationHeader || 'Location'}} Country*</p>
                <lb-tagsInput :multiple="false" :multiplechips="false" v-model="locationdata.country"
                :hidedetails="false" :error="locationdataerror.country" :items="countryList" itemtext="name" itemvalue="value" appendiconinner="mdi-chevron-down" data-testid="location-new__drawer-country-input"/>
              </v-col>
              <v-col cols="6" class="my-0 py-1" data-testid="location-new__drawer-col-type">
                <p class="pa-0 ma-0  text-font-size-md mb-1">{{$store.state.LocationHeader || 'Location'}} Type*</p>
                <lb-dropdown v-model="locationdata.type" :items="locationtypeItem" label=""
                  :error="locationdataerror.type" itemtext="name" itemvalue="value"
                  @change="locationNew(locationdata.type)" data-testid="location-new__drawer-type-input" />
              </v-col>
              <v-col v-if="locationtypedialog" cols="6" class="my-0 py-1" data-testid="location-new__drawer-col-newtype">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Add New {{$store.state.LocationHeader || 'Location'}} Type</p>
                <lb-string v-model="locationdata.newtype" label="" placeholder="Enter Type..." :error="locationdataerror.newtype" data-testid="location-new__drawer-newtype-input" />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" data-testid="location-new__drawer-submit-btn">
            <span v-if="locationdata._id" @click="updateLocation(locationdata)" data-testid="location-new__drawer-update-label">Update</span>
            <span v-else @click="addLocation()" data-testid="location-new__drawer-add-label">Add</span>
          </v-btn>
        </template>
      </lb-drawer>

      <!-- Pagination Component -->
      <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="location-new__pagination" />

    </div>
</template>

<script>
    import Pagination from "../../components/Pagination/Pagination.vue";
    import CustomizeColumnMenu from "../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
    import ActivityLog from "../../components/ActivityLog/ActivityLog.vue";
      export default {
        data() {
          return {
            right: "financialclose_location_master",
            locationdialog: false,
            locationdialogloading: false,
            locationdata: {},
            locationdataerror: {},
            loading: false,
            locationtypeItem: [],
            formatedData: [],
            erpRunningStatus: false,
            lastRunData: {},
            erplocation:'Skinlaundry-location-pipeline',
            formatedDataCopy:[],
            locationtypedialog: false,
            activeColumnFilters: {},
            customizeMenuOpen: false,
            page_details: {
              pagename: 'location-master',
              cycle_id: (this.$store?.state?.client) || 'global'
            },
            headers: [
              {
                value: "name",
                text: "Name",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "description",
                text: "Description",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "type",
                text: "Type",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "country",
                text: "Country",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "scource",
                text: "Source",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "ingestion_type",
                text: "Ingestion Type",
                visible: true,
                filterable:true,
                sortable: true,
              },
              {
                value: "action",
                text: "Action",
                sortable: false,
                datatype: "action",
                lock: true,
                visible: true,
                alignment: "text-center",
              },
            ],
            listdata: [],
            hasActiveTableFilter: false,
            countryList:[],
            editHeader:false,
            newHeader:'Location',
            searchcolumn:"",
            searchTerm:"",
            search:"",
            itemsPerPage:13,
            paginatedFilteredItems:[],
          };
        },
        created() {
          this.refreshData();
        },
        components: {
          Pagination,
          CustomizeColumnMenu,
         ActivityLog
        },
        computed:{
            filteredHeaders() {
              const searchTerm = this.searchcolumn.toLowerCase();
              return this.headers.filter(header =>
                header.value.toLowerCase()?.includes(searchTerm)
              );
            },
            filteredItemsfromsearch() {
                let filteredData = this.formatedData.filter(item =>
                    item.description.toLowerCase().includes(this.search.toLowerCase())
                );
                return filteredData;
            },
        },
        watch: {
          '$store.state.client'(newVal) {
            this.page_details.cycle_id = newVal || 'global';
          },
          search() {
            this.updatePaginationAfterFilter();
          },
          itemsPerPage() {
            this.updatePaginationAfterFilter();
          }
        },
        methods: {
          /**
           * Handler for filter-active-change event from DataTableAction
           */
          onFilterActiveChange(isActive) {
            this.hasActiveTableFilter = isActive;
          },
          /**
           * Clear table filters via DataTableAction ref
           */
          clearTableFilter() {
            if (this.$refs.dataTableAction) {
              this.$refs.dataTableAction.clearFilter();
            }
          },
          async syncERP() {
            this.loading = true;
            try {

              if(this.$store.state.erpEnabled.locationErpEnabled === false){
                return;
              }
              if(this.erpRunningStatus) await this.stopErpPipeline()

                const dt = await this.axios.post("v2/erp/sync-location");
                const msg = dt.data.message;
                if (dt.data.status === "success") {
                    this.$store.commit("sbSuccess", msg || "Sync started!");
                    this.fetchErpPipelineStatus();

                } else {
                    this.$store.commit("sbError", msg || "Sync failed!");
                }
            } catch (err) {
                this.$store.commit("sbError", err?.message || err || "Unknown error!");
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
         // --- ERP TB Pipeline Status Helpers ---
      
         async fetchErpPipelineStatus() {
            try {
          // optional local loading flag (reuse page loading if desired)
          if(this.$store.state.erpEnabled.locationErpEnabled === false){
                return;
              }
          const { data } = await this.axios.post('/v2/erp/check-status', {
              type: 'check',
              processgroup: this.erplocation
          });
          if (data?.status === 'success') {
            if(data.data?.raw.status === 'success'){
              // this.$store.commit("sbSuccess", data.data.message || "Erp is ");
              const isRunning = !!(data.data?.running);
              this.erpRunningStatus = isRunning;
            }
            else
              this.$store.commit("sbError", data.data.message || "Sync failed!");
          }
            } catch (e) {
          console.error('Failed to fetch ERP TB running status', e);
            }
        },
        async fetchLastUpdatedAt() {
            try {
          // optional local loading flag (reuse page loading if desired)
          if(this.$store.state.erpEnabled.locationErpEnabled === false){
                return;
              }
          const { data } = await this.axios.post('/v2/erp/get-status', {
              type: 'locations',
              processgroup: this.erplocation
          });
          if (data?.status === 'success') {
              this.lastRunData = data.data;
          }
            } catch (e) {
          console.error('Failed to fetch ERP TB status', e);
            }
        },
        async stopErpPipeline() {

            try {

              if(this.$store.state.erpEnabled.locationErpEnabled === false){
                return;
              }   
          const { data } = await this.axios.post('/v2/erp/check-status', {
            type: 'stop',
            processgroup: this.erplocation
          });
          if (data?.status === 'success') {
              const isRunning = !!(data.data?.running);
              this.erpRunningStatus = isRunning;
          }
            } catch (e) {
          console.error('Failed to stop ERP TB pipeline', e);
            }
        },
          setPaginatedData(paginationInfo) {
            if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
                this.paginatedFilteredItems = paginationInfo.data || [];
                this.page = paginationInfo.page || 1;
            } else {
                this.paginatedFilteredItems = paginationInfo || [];
            }
          },
          updatePaginationAfterFilter() {
            const current = this.filteredItemsfromsearch || [];
            this.paginatedFilteredItems = current.slice(0, this.itemsPerPage);
          },
          applyActiveFilters() {
            const hasFilters = Object.keys(this.activeColumnFilters || {}).length > 0;
            if (hasFilters) {
              this.formatedData = this.$nova.filterByDynamicCriteria(this.formatedDataCopy, this.activeColumnFilters);
            } else {
              this.formatedData = this.formatedDataCopy.slice();
            }
            this.updatePaginationAfterFilter();
          },
          refreshData(){
            this.getData();
            this.fetchErpPipelineStatus();
            this.fetchLastUpdatedAt();
          },
          getItemData(item, key) {
              return item[key];
          },
          formateData() {
            let ObjectTemp = {};
            let ArrayTemp = [];
            this.listdata.forEach((item, index) => {
              ObjectTemp = {
                __key: index,
                __formatedkey: index,
                _id: item._id,
                indexno: index + 1,
                name: item.name,
                description: item.description,
                ingestion_type: this.ingestionTypeCheck(item.ingestion_type),
                country: item.country,
                type: item.type,
                created_at: item.created_at,
                updated_at: item.updated_at,
                status: item.status,
              };
              ArrayTemp.push(ObjectTemp);
            });
            this.formatedDataCopy = ArrayTemp;
            this.applyActiveFilters();
          },
         ingestionTypeCheck(item) {
            return item || "Manual";
          },
          getData() {
            this.loading = true;
            this.axios
              .post("/v2/financialclose/location/get")
              .then((ele) => {
                if (ele.data.status === "success") {
                  this.listdata = ele.data.data;
                  this.formateData();
                  this.axios
                    .post("/v2/financialclose/location/formselects")
                    .then((ele) => {
                      let locationtypelist = ele.data.data;
                      this.locationtypeItem = locationtypelist[0].type;
                      this.countryList = locationtypelist[0].countryList;
                      this.countryList = this.countryList.map(item => item.name);
                      
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          },
          /**
           * Validate location data fields before add/edit API call
           * Checks for null, undefined, empty, and length constraints
           * Returns an object with error messages for each invalid field
           */
          validateLocationData(data) {
            const errors = {};
            // Name validation
            if (!data.name || typeof data.name !== 'string' || !data.name.trim() || data.name.trim().length < 2) {
              errors.name = 'Name is required.';
            }
            // Description validation
            if (!data.description || typeof data.description !== 'string' || !data.description.trim() || data.description.trim().length < 2) {
              errors.description = 'Description is required.';
            }
            // Country validation
            if (!data.country || (Array.isArray(data.country) && data.country.length === 0) || (typeof data.country === 'string' && !data.country.trim())) {
              errors.country = 'Country is required.';
            }
            // Type validation
            if (!data.type || typeof data.type !== 'string' || !data.type.trim()) {
              errors.type = 'Type is required.';
            }
            return errors;
          },

          addLocation() {
            // Validate before API call
            const errors = this.validateLocationData(this.locationdata);
            this.locationdataerror = errors;
            if (Object.keys(errors).length > 0) {
              this.$store.commit("sbError", "Please fill all required fields correctly.");
              return;
            }
            this.loading = true;
            this.axios
              .post("/v2/financialclose/location/add", { data: this.locationdata })
              .then((ele) => {
                if (ele.data.status === "success") {
                  this.locationdialog = false;
                  this.$store.commit("sbSuccess", "added successfully");
                  this.getData();
                } else {
                  if (ele.data.data.length > 0) {
                    if (ele.data.data[0].index0)
                      this.locationdataerror = ele.data.data[0].index0;
                  } else {
                    this.$store.commit("sbError", ele.data.message || "Location not added");
                    throw new Error(ele.data.message);
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          },
          editLocation(item) {
            this.locationdata = {...item};
            this.locationdata.type = item.type;
            let typeObj = {
              name: this.locationdata.type,
              value: this.locationdata.type,
            };
            this.locationtypeItem.push(typeObj);
      
            this.locationdialog = true;
            this.locationdataerror = {};
            console.log(item);
          },
          updateLocation(item) {
            // Validate before API call
            const errors = this.validateLocationData(item);
            this.locationdataerror = errors;
            if (Object.keys(errors).length > 0) {
              this.$store.commit("sbError", "Please fill all required fields correctly.");
              return;
            }
            this.loading = true;
            this.axios
              .post("v2/financialclose/location/edit/"+ item._id, {  data: item })
              .then((ele) => {
                if (ele.data.status === "success") {
                  this.locationdialog = false;
                  this.$store.commit("sbSuccess", "update successfully");
                  this.getData();
                }else {
                 if (ele.data.data.length > 0) {
                    if (ele.data.data[0].index0)
                      this.locationdataerror = ele.data.data[0].index0;
                  } else {
                    this.$store.commit("sbError", ele.data.message || "Location not updated");
                    throw new Error(ele.data.message);
                  };
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          },
          locationNew(name) {
            if (name === "Other") {
              this.locationtypedialog = true;
            }
            else{
                this.locationtypedialog=false;
            }
          },
          locationtypeAdd(type) {
            let typeObj = { name: type, value: type };
            this.locationtypeItem.push(typeObj);
            this.locationdata.type = type;
            this.locationtypedialog = false;
          },
          enableDisable(id, action) {
            this.loading = true;
            let url = "/v2/financialclose/location/disable/";
            if (action === "enable") {
              url = "/v2/financialclose/location/enable/";
            }
            this.axios
              .post(url + id, {})
              .then((dt) => {
                if (dt.data.status === "success") {
                  if (action === "enable") {
                    this.getData();
                    this.$store.commit("sbSuccess", "Item enabled");
                  } else {
                    this.getData();
                    this.$store.commit("sbSuccess", "Item disabled");
                  }
                } else throw new Error(dt.data.message || "Error performing action");
              })
              .catch((err) => {
                this.$store.commit("sbError", err.message || err || "Unknown error!");
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          },
          addTableHeader(item) {
            this.headers.find((x) => x === item ? x.visible = !x.visible : "")
          },

          /**
           * Handle Apply button click from CustomizeColumnMenu
           * Updates column visibility locally (session only)
           * @param {Array} headers - Updated headers array
           */
          handleApplyColumns(headers) {
            this.headers = headers;
            this.customizeMenuOpen = false;
          },
    
          async UpdateHeader(){
            if(this.newHeader?.trim())
            {
              try {
                const dt = await this.axios.post("v2/client/edit",
                  {data:{'location': this.newHeader.trim(), userlist:[] },
                    id: this.$route.query.cid || "",
                  });
                
                const location = dt.data?.data?.[0]?.location;
                
                if(dt.data.status=='success' && location)
                {
                  this.$store.commit("sbSuccess", "Header Updated Successfully")
                  this.$store.commit('setLocationHeader', location)
                  this.newHeader = location
                  await this.getLocationHeader()
                  this.editHeader=false
                }
                else
                {
                  this.$store.commit("sbError", dt.data.message || "Unknown error!");
                }
              } catch(err) {
                this.$store.commit("sbError", err.message || "Failed to update header");
                console.error(err);
              }
            }
            else
            {
              this.$store.commit("sbError", "Cannot keep the header empty")
            }
          },
        async getLocationHeader(){
          try {
            const dt = await this.axios.post("v2/client/getlocation");
            const location = dt.data?.data?.[0]?.location;
            if(location) {
              this.$store.commit('setLocationHeader', location);
              this.newHeader = location;
            }
          } catch(err) {
            console.error("Failed to get location header:", err);
          }
        },
        filterPart(item){
            this.activeColumnFilters = JSON.parse(JSON.stringify(item || {}));
            this.applyActiveFilters();
          },
        clearPart(){
            this.activeColumnFilters = {};
            this.applyActiveFilters();
          }
    
        },
      };
</script>

<style>
</style>